import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)

export const FORM_CONFIG = formConfig
export const FORM_NAME = formConfig.formName
export const FORM_TITLE = formConfig.formTitle
export const FORM_DESCRIPTION = formConfig.formDescription

export const EditControlPlaneResourceInstanceFormSchema = z.object({
  instanceNumber: z
    .number()
    .int()
    .optional(), // Business key for edit/upsert
  resourceTypeNumber: z
    .coerce
    .number()
    .int('Resource Type must be selected')
    .min(1, 'Resource Type is required'),
  instanceName: z
    .string()
    .min(2, 'Instance Name must be at least 2 characters')
    .max(100, 'Instance Name cannot exceed 100 characters'),
  instanceDescription: z
    .string()
    .min(1, 'Description is required')
    .max(500, 'Description cannot exceed 500 characters'),
  instancePath: z
    .string()
    .min(1, 'Path is required')
    .max(300, 'Path cannot exceed 300 characters'),
  instanceAccessPolicy: z
    .string()
    .min(1, 'Access Policy is required')
    .max(500, 'Access Policy cannot exceed 500 characters'),
})

export type EditControlPlaneResourceInstanceFormData = z.infer<typeof EditControlPlaneResourceInstanceFormSchema>

export function transformToApiRequest(formData: EditControlPlaneResourceInstanceFormData) {
  return {
    instanceNumber: formData.instanceNumber, // Business key for edit/upsert
    resourceTypeNumber: formData.resourceTypeNumber,
    resourceInstanceName: formData.instanceName.trim(),
    resourceInstanceDescription: formData.instanceDescription.trim(),
    resourceInstancePath: formData.instancePath.trim(),
    resourceAccessPolicy: formData.instanceAccessPolicy.trim(),
  }
}
